// src/apis/auth.js
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

export const signupUser = async (data) => {
  return axios.post(`${API_BASE}/api/auth/signup`, data);
};

export const loginUser = async (data) => {
  return axios.post(`${API_BASE}/api/auth/login`, data);
};

export const loginUserWithGoogle = async (data) => {
  return axios.post(`${API_BASE}/api/auth/googleLogin`, data);
};

export const sendResetOtp = async (data) => {
  return axios.post(`${API_BASE}/api/auth/send-reset-otp`, data);
};

export const resetPassword = async (data) => {
  return axios.post(`${API_BASE}/api/auth/reset-password`, data);
};
